import { h } from 'preact';
import { getRatingsBySecurity } from '@os/cloudquote';
import { Icon } from '@cube/blocks';
import { Text } from 'preact-i18n';
import { intlDateNode, camel } from '../../lib/util';
import cx from 'classnames';
import createDataTable, { tableUtils } from '../cloudquote-data-table';
import style from './style';

const INTL_NS = 'analysts-panel.upgradeDowngrade';

function pick(data, key) {
	return String(data.row[data.columns.indexOf(key)] || '');
}

const ICON_MAP = {
	upgrade: 'arrow-up',
	downgrade: 'arrow-down'
};

const UpDownCell = (props) => {
	let type = pick(props, 'type') || '';
	// Camel-case the id for multi-word results to map to INTL.json keys
	let typeId = camel(type);

	let iconType = ICON_MAP[type.toLowerCase()];
	let icon = iconType && <Icon name={iconType} />;

	return (
		<span class={cx(style.upOrDown, style[type.toLowerCase()])}>
			{icon}{' '}<Text id={`${INTL_NS}.${typeId}`}>{type}</Text>
		</span>
	);
};

const FirmAndRatingCell = (props) => (
	<div>
		<div>
			{pick(props, 'firm')}
		</div>
		<div>
			{<Text id={`${INTL_NS}.${camel(pick(props, 'rating'))}`}>{pick(props, 'rating')}</Text>}
		</div>
	</div>
);

const DataTable = createDataTable({
	headers: [
		<Text id={`${INTL_NS}.upgradesDowngrades`} />,
		<Text id={`${INTL_NS}.firmName`} />,
		<Text id={`${INTL_NS}.date`} />
	],
	cells: [
		UpDownCell,
		FirmAndRatingCell,
		tableUtils.formatField('ratingDate', intlDateNode)
	],
	sort: tableUtils.sort.descending.dateByKey('ratingDate'),
	apiMethod: ({ symbol }) => getRatingsBySecurity(symbol),
	maxRows: 5
});

export const UpgradeDowngradeDataTable = (props) => (
	<div class={style.upgradesDowngrades}>
		<DataTable {...props} />
	</div>
);
